import React, { FC, useEffect, useRef, useState } from "react";
import { Modal, Radio, Select } from "antd";
import { TreeSelect } from "antd";
import { deserialize } from "serializr";
import { PlayCircleOutlined } from '@ant-design/icons';
import closeIcon from "../../../assets/icons/close.svg";
import "./productForm.scss";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import InputField from "../../../shared/components/InputField";
import UploadLogo from "../../../shared/components/UploadLogo";
import { Skeleton } from "antd";

import { serialize } from "serializr";
import { convertJSONToFormData } from "../../../shared/utils/converJsonToFormData";
import { ProductModel } from "../../../models/ProductModel/products.model";
import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";

import { productFormValidation } from "./validation";

import CommonService from "../../../services/CommonService/common.service";
import ProductService from "../../../services/ProductService/products.service";
import Error from "../../../shared/components/Error";


interface ProductFormProps {
  loading: boolean,
  title: string;
  visible: boolean;
  setVisible: Function;
  data?: any;
  setCurrentContent: Function;
  refreshData: Function;
}

const ProductForm: FC<ProductFormProps> = (props) => {
  const { loading, title, visible, setVisible, data, refreshData, setCurrentContent } = props;
  const formRef = useRef<any>();

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>();


  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [sectionSubjects, setSectionSubjects] = useState<MetaModel[]>([]);

  const fetchBoards = (InitialState: any) => {
    CommonService.fetchBoardsMeta(
      (boardData) => {
        const meta = deserialize(MetaModel, boardData) as MetaModel[];
        setBoards(meta);
        if (meta.length) {
          let value = Number(meta[0].value)
          if (data?.boardId) {
            setInitialValues((prevState) => { return { ...InitialState, BoardId: data?.boardId } })
          } else {
            setInitialValues((prevState) => { return { ...InitialState, BoardId: value } })
          }
          fetchGrades(value)
        }
      },
      () => { },
      () => { }
    );
  };


  const fetchGrades = (id: number) => {
    CommonService.fetchGradeMetaByBoard(
      id,
      (GradeData) => {
        const meta = deserialize(MetaModel, GradeData) as MetaModel[];
        setClassRooms(meta);
        setInitialValues((prevState) => { return { ...prevState, ClassId: data?.classId || null } })
        if (data?.classId)
          fetchSectionSubjects(data?.classId)

      },
      () => { },
      () => { }
    );
  };

  const fetchSectionSubjects = (id: number) => {
    CommonService.fetchSubjectsMeta(
      id,
      (subjectData) => {
        const response = deserialize(MetaModel, subjectData);
        setSectionSubjects(response);
        console.log(data?.subjectId);
        setInitialValues((prevState) => { return { ...prevState, SubjectId: data?.subjectId || undefined } })
      },
      () => { },
      () => { }
    );
  };
  useEffect(() => {
    const InitialState = {
      displayPicture: null,
      ProductId: data?.productId || 0,
      ProductName: data?.productName || null,
      Description: data?.description || null,
      Price: data?.price || null,
      BoardId: data?.boardId || null,
      ClassId: data?.classId || null,
      SubjectId: data?.subjectId || undefined,
      Duration: data?.duration || null,
      ThumbnailImage: data?.thumbnailImage || null,
    }
    //setInitialValues(InitialState);
    fetchBoards(InitialState);
  }, [data, visible]);




  const handleClose = () => {
    setVisible(false);
    setCurrentContent("");
    setInitialValues({})
    formRef.current.resetForm();
  };



  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    let contentData = serialize(ProductModel, values);
    if (values.ProductId === undefined) contentData.ProductId = 0;
    if (values.displayPicture) contentData.ThumbnailImage = values.displayPicture;
    if (values.SubjectId) values.SubjectId.includes('null') ? contentData.SubjectId = [] : contentData.SubjectId = values.SubjectId
    contentData.IsActive = true

    let contentFormData = convertJSONToFormData(contentData);
    if (!data) {
      ProductService.createProduct(
        contentFormData,
        () => {
          refreshData();
          formRef.current.resetForm(initialValues);
          setVisible(false);
        },
        () => { },
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else {
      ProductService.updateProduct(
        contentFormData,
        () => {
          refreshData();
          formRef.current.resetForm(initialValues);
          setVisible(false);

        },
        () => { },
        () => {
          setButtonLoading(false);
        }
      ).then();
    }
  };



  if (!visible) {
    return null
  }





  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className="board-form__modal content-form__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      {loading
        ? <div style={{ padding: 20 }}>
          <Skeleton.Image active ></Skeleton.Image>
          <br></br>
          <br></br>
          <Skeleton paragraph={{ rows: 5 }} active ></Skeleton>
          <Skeleton.Node active>
            <PlayCircleOutlined style={{ fontSize: 40, color: '#bfbfbf' }} />
          </Skeleton.Node>
          <br></br>
          <br></br>
          <Skeleton paragraph={{ rows: 3 }} active ></Skeleton>
        </div>
        : <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          innerRef={formRef}
          validationSchema={productFormValidation}
        >
          {({ setFieldValue, values, resetForm }) => {
            return (
              <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className="board-form__header">
                  <div className="board-form__title">{title}</div>
                </div>
                <div className="content-form__thumbnail">
                  <Field name="displayPicture" as="file-upload">
                    <UploadLogo
                      logoUrl={
                        values?.displayPicture
                          ? values?.displayPicture
                          : data?.ThumbnailImage
                      }
                      setFile={setFieldValue}
                      uploadText="Upload thumbnail"
                    />
                  </Field>
                </div>



                <div className="board-form__input">
                  <div className="board-form__label">Product Name</div>
                  <InputField
                    type="text"
                    name="ProductName"
                    placeholder="Type content title"
                  />
                </div>
                <div className="dashboard-filter-form__wrapper">
                  <div
                    className="dashboard-filter-form__field"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <label>Board</label>
                    <Field

                      as={Select}
                      name="BoardId"
                      placeholder="Select Board"
                      options={boards}
                      value={values?.BoardId}
                      onChange={(value) => {
                        setFieldValue("BoardId", value);
                        fetchGrades(value)
                      }}
                    />
                    <ErrorMessage name="BoardId">
                      {(message: string) => <Error message={message} />}
                    </ErrorMessage>
                  </div>



                  <div
                    className="dashboard-filter-form__field"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <label>Class</label>
                    <Field
                      as={Select}
                      name="ClassId"
                      placeholder="Select Class"
                      options={classRooms}
                      value={values?.ClassId}
                      onChange={(value) => {
                        setFieldValue("ClassId", value);
                        fetchSectionSubjects(value)
                      }}
                    />
                    <ErrorMessage name="ClassId">
                      {(message: string) => <Error message={message} />}
                    </ErrorMessage>
                  </div>

                  <div
                    className="dashboard-filter-form__field"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <label>Subject</label>
                    <Field as="tree-select" name="SubjectId">
                      <TreeSelect
                        style={{ width: "100%" }}
                        value={values?.SubjectId}
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        treeData={[
                          {
                            title: 'All',
                            value: 'null',
                            key: 'null',
                            children: [...sectionSubjects],
                          },
                        ]}
                        placeholder="Search"
                        allowClear
                        multiple
                        treeCheckable={true}
                        treeDefaultExpandAll={true}
                        showCheckedStrategy={TreeSelect.SHOW_PARENT}
                        onChange={(value) => {
                          setFieldValue("SubjectId", value);
                        }}
                      />
                      <ErrorMessage name="SubjectId">
                        {(message: string) => <Error message={message} />}
                      </ErrorMessage>
                    </Field>
                  </div>

                </div>


                <div className="board-form__input">
                  <div className="board-form__label">Price</div>
                  <InputField
                    type="number"
                    name="Price"
                    placeholder="Type Price"
                  />
                </div>


                <div className="board-form__input">
                  <div className="board-form__label">Duration</div>
                  <InputField
                    type="number"
                    name="Duration"
                    placeholder="Type Duration"
                  />
                </div>

                <div className="board-form__input">
                  <div className="board-form__label">Description</div>
                  <InputField
                    type="textarea"
                    rows={4}
                    name="Description"
                    placeholder="Type description"
                  />
                </div>






                <div className="board-form__action">
                  <div
                    className="board-form__button"
                    onClick={() => {
                      handleClose();
                      //resetForm();
                    }}
                  >
                    <ButtonComponent buttonContent="Cancel" type="text" />
                  </div>
                  <div className="board-form__button">
                    <ButtonComponent
                      buttonContent={data ? "Update" : "Create"}
                      type="primary"
                      htmlType="submit"
                      loading={buttonLoading}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      }
    </Modal>
  );
};

export default ProductForm;
